import React from 'react';
import { ProductContainer } from '../../container';

const ProductPage = () => {
  return (
    <div>
      <ProductContainer />
    </div>
  );
};

export default ProductPage;
